import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  Box,
  ButtonStyled,
  SpanStyled,
  SubHeadingStyled,
  DataContainerHeader,
  TextStyled,
  CheckList,
  ThemeLoader,
  DurationToggleContainer,
  DurationToggle,
  DurationOption,
} from "../../../components/styled/Elements";
import {
  SettingsWrapper,
  FormDataContainer,
  SubscriptionWrapper,
} from "./styled";
import { useLocation, useNavigate } from "react-router-dom";
import {
  basicPlanCheckList,
  enterprisePlanCheckList,
  professionalPlanCheckList,
} from "../../../helpers/dummyConstants";
import { Chat, CreditCard, Edit } from "../../../components/styled/AllImages";
import AddLicenseModal from "../../../components/admin/Modals/AddLicense/AddLicenseModal";
import ContactSalesModal from "../../../components/admin/Modals/ContactSales/contactSalesModal";
import BillingApi from "../../../services/api/billingApi";
import { useUser } from "../../../context/userContext";
import { toast } from "react-toastify";
import AuthApi from "../../../services/api/authApi";
import { formateAmounts } from "../../../utils";
import CreditCardInfoModal from "../../../components/admin/Modals/CreditCardInfoModal/CreditCardInfoModal";

const SubscriptionPlan = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { user, fetchUserInfo } = useUser();
  const navigate = useNavigate();

  const [action, setAction] = useState(null);
  const [autoSubscibe, setAutoSubscribe] = useState(
    user?.current_organization?.auto_subscription
  );
  const [planData, setPlanData] = useState({
    id: user?.current_organization?.plan_detail?.plan_id,
    amount: user?.current_organization?.plan_detail?.price,
    expired: user?.current_organization?.plan_detail?.expired,
  });
  const [loading, setLoading] = useState(false);
  const [statusUpdateLoading, setStatusUpdateLoading] = useState(false);
  const [showAddLicenseModal, setShowAddLicenseModal] = useState(false);
  const [showContactSalesModal, setShowContactSalesModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [plansList, setPlansList] = useState([]);
  const [modalTitle, setModalTitle] = useState(""); // State for modal title
  const [selectedDuration, setSelectedDuration] = useState(1);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get("status");

  const isCustomHighlighted =
    user?.current_organization?.plan_detail?.plan?.type === "private";

  const clearParams = () => {
    // Navigate to the same path without search params
    navigate(location.pathname, { replace: true });
  };

  const addLicense = (title, plan) => {
    if (plan && plan?.id == planData?.id && !planData?.expired) {
      setAction("extend");
      setPlanData({
        id: plan?.id,
        amount:
          plan?.plan_prices?.find(
            (price) => price?.duration == selectedDuration
          )?.price || "",
        duration: selectedDuration || 1,
      });
    } else if (
      (plan && plan?.id != planData?.id) ||
      (plan?.id == planData?.id && planData?.expired)
    ) {
      setAction("renew");
      setPlanData({
        id: plan?.id,
        amount:
          plan?.plan_prices?.find(
            (price) => price?.duration == selectedDuration
          )?.price || "",
        duration: selectedDuration || 1,
      });
    } else {
      setAction("extend");
      setPlanData({
        id: user?.current_organization?.plan_detail?.plan_id,
        amount: user?.current_organization?.plan_detail?.price,
        expired: user?.current_organization?.plan_detail?.expired,
        type: user?.current_organization?.plan_detail?.plan?.type,
      });
    }
    setModalTitle(title); // Set the modal title based on the button clicked
    setShowAddLicenseModal(true); // Show the modal
  };
  const contactSales = () => {
    setShowContactSalesModal(true); // Show the modal
  };
  // const [checkSelectedValueID, setcheckSelectedValueID] = useState(null);
  // const checkSelectedValue = (e) => {
  //     setcheckSelectedValueID(Number(e.target.value));
  // };
  // const { register } = useForm();
  const handleButtonClick = () => {
    // setcheckSelectedValueID(Number(e.target.value));
  };

  useEffect(() => {
    if (user?.current_organization) {
      setAutoSubscribe(user?.current_organization?.auto_subscription);
    }
  }, [user]);
  const onStatusToggle = async () => {
    if (!statusUpdateLoading) {
      try {
        setStatusUpdateLoading(true);
        const { data, code, message } = await BillingApi.autoSubscribeStatus(
          autoSubscibe ? 0 : 1
        );
        if (code === 200 && data) {
          await fetchUserInfo();
          toast.success(
            autoSubscibe
              ? t("auto_renewal_turned_off")
              : t("auto_renewal_turned_on")
          );
        } else {
          toast.error(message);
        }
      } catch (error) {
      } finally {
        setStatusUpdateLoading(false);
      }
    }
  };

  const getPlansList = async () => {
    try {
      setLoading(true);
      const { data } = await BillingApi.getPlansList();
      setPlansList(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const requestGracePeriod = async () => {
    try {
      const { code, message, data } = await BillingApi.requestGracePeriod();
      if (code === 200) {
        toast.success(message);
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {
    } finally {
    }
  };

  useEffect(() => {
    getPlansList();
  }, [language]);

  useEffect(() => {
    if (status) {
      if (status === "CAPTURED") {
        fetchUserInfo();
        toast.success(t("payment_successful")); // you can customize this message
        clearParams();
      } else if (status === "DECLINED") {
        toast.error(t("payment_failed")); // you can customize this message
        clearParams();
      }
    } else fetchUserInfo();
  }, [status]);

  return (
    <SettingsWrapper>
      <Box className="content-head">
        <SubHeadingStyled size="16px" color="var(--text)">
          {t("settings")}
        </SubHeadingStyled>
      </Box>
      <Box className="content-container">
        <Row className="mt-3">
          <Col md={12}>
            <FormDataContainer className="dataContainer">
              <DataContainerHeader
                label={t("subscription_plan")}
                // btnLabel="card_info"
                // icon={CreditCard}
                // onClick={() => {
                //   setShowModal(true);
                // }}
              />
              <SubscriptionWrapper>
                {loading ? (
                  <ThemeLoader />
                ) : (
                  <Box>
                    <DurationToggleContainer className="mt-0">
                      <DurationToggle>
                        <DurationOption
                          active={selectedDuration === 1}
                          onClick={() => setSelectedDuration(1)}
                        >
                          {t("monthly")}
                        </DurationOption>
                        <DurationOption
                          active={selectedDuration === 12}
                          onClick={() => setSelectedDuration(12)}
                        >
                          {t("annually")}
                        </DurationOption>
                      </DurationToggle>
                    </DurationToggleContainer>
                    <Row>
                      {plansList &&
                        plansList.length > 0 &&
                        plansList.map((plan) => {
                          const selectedPriceObj = plan?.plan_prices.find(
                            (p) => p?.duration === selectedDuration
                          );
                          const price = selectedPriceObj
                            ? parseFloat(selectedPriceObj.price)
                            : 0;
                          const duration = selectedPriceObj
                            ? parseFloat(selectedPriceObj?.duration)
                            : 1;
                          const isExpired =
                            plan?.id ==
                              user?.current_organization?.plan_detail
                                ?.plan_id &&
                            user?.current_organization?.plan_detail?.expired &&
                            !user?.current_organization?.plan_detail
                              ?.is_grace_period_active;
                          console.log(isExpired, plan.id);

                          const isFree = plan.category === "free";
                          const isHighlighted =
                            plan?.id ==
                            user?.current_organization?.plan_detail?.plan_id; // You can change condition based on your design
                          const buttonLabel =
                            plan?.id ==
                            user?.current_organization?.plan_detail?.plan_id
                              ? t("RenewPlan")
                              : t("upgrade");

                          const features =
                            language === "en"
                              ? plan?.features_en
                              : plan?.features_ar;

                          let rawFeaturesStr = "";

                          if (Number(selectedDuration) === 1) {
                            rawFeaturesStr =
                              language === "en"
                                ? plan?.monthly_features_en ??
                                  plan?.monthly_features ??
                                  ""
                                : plan?.monthly_features_ar ??
                                  plan?.monthly_features ??
                                  "";
                          } else if (Number(selectedDuration) === 12) {
                            rawFeaturesStr =
                              language === "en"
                                ? plan?.annual_features_en ??
                                  plan?.annual_features ??
                                  ""
                                : plan?.annual_features_ar ??
                                  plan?.annual_features ??
                                  "";
                          } else {
                            // fallback to monthly if some weird duration
                            rawFeaturesStr =
                              language === "en"
                                ? plan?.monthly_features_en ??
                                  plan?.monthly_features ??
                                  ""
                                : plan?.monthly_features_ar ??
                                  plan?.monthly_features ??
                                  "";
                          }

                          // safe JSON parse
                          let featuresArr = [];
                          try {
                            if (rawFeaturesStr)
                              featuresArr = JSON.parse(rawFeaturesStr);
                          } catch (err) {
                            console.warn(
                              "Could not parse features for plan:",
                              plan.id,
                              err
                            );
                            featuresArr = [];
                          }

                          const featuresList = (featuresArr || []).map(
                            (item, i) => ({
                              id: i + 1,
                              listTxt:
                                typeof item === "string"
                                  ? item.trim()
                                  : String(item),
                            })
                          );

                          if (isFree) return;

                          return (
                            <Col lg={6} xl={4} className="mb-4" key={plan.id}>
                              <Box
                                className={`planDataContainer ${
                                  isHighlighted ? "planDataContainerBlue" : ""
                                }`}
                              >
                                <Box className="headToTxt">
                                  <SubHeadingStyled
                                    color="var(--text)"
                                    size="24px"
                                  >
                                    {t(plan.title)}
                                  </SubHeadingStyled>

                                  <Box className="descBox">
                                    <TextStyled
                                      size="15px"
                                      color="var(--text2)"
                                    >
                                      {t(plan.description)}
                                    </TextStyled>

                                    {plan?.id ==
                                      user?.current_organization?.plan_detail
                                        ?.plan_id && (
                                      <TextStyled
                                        size="12px"
                                        color="var(--redColor)"
                                      >
                                        {t("expiry_date")}:{" "}
                                        {
                                          user?.current_organization
                                            ?.plan_detail?.expiration_date
                                        }{" "}
                                        {/* Replace with real expiry if available */}
                                      </TextStyled>
                                    )}
                                  </Box>

                                  {isFree ? (
                                    <Box className="subsPriceCurrency">
                                      <SpanStyled
                                        className="subsPrice"
                                        size="28px"
                                        color="var(--themeColor2)"
                                      >
                                        0
                                      </SpanStyled>
                                      <SpanStyled
                                        className="subsCurrency"
                                        size="16px"
                                        color="var(--themeColor2)"
                                      >
                                        {t("usd")}
                                      </SpanStyled>
                                    </Box>
                                  ) : (
                                    <Box className="subsPriceCurrency">
                                      <SpanStyled
                                        className="subsPrice"
                                        size="28px"
                                        color="var(--themeColor)"
                                      >
                                        {formateAmounts(price)}
                                      </SpanStyled>
                                      <SpanStyled
                                        className="subsCurrency"
                                        size="16px"
                                        color="var(--themeColor)"
                                      >
                                        {t("usd")}
                                      </SpanStyled>
                                    </Box>
                                  )}

                                  <TextStyled size="14px" color="var(--text)">
                                    {/* {plan.duration} */}
                                    {plan?.category === "free"
                                      ? t("free_forever")
                                      : duration == 1
                                      ? t("monthly")
                                      : duration == 12
                                      ? t("annually")
                                      : "N/A"}
                                    {/* {plan.duration === "yearly"
                                      ? t("peruseryear")
                                      : t("perusermonth")} */}
                                  </TextStyled>
                                </Box>
                                <Box className="commonBtns w-100 p-0 mt-3">
                                  <ButtonStyled
                                    border={
                                      isFree
                                        ? "var(--themeColor2)"
                                        : "var(--themeColor)"
                                    }
                                    bg={
                                      isFree
                                        ? "transparent"
                                        : "var(--themeColor)"
                                    }
                                    color={
                                      isFree
                                        ? "var(--themeColor2)"
                                        : "var(--white)"
                                    }
                                    size="20px"
                                    padding="12px 20px"
                                    weight="bold"
                                    clName="w-100"
                                    className="w-100"
                                    label={buttonLabel}
                                    onClick={() =>
                                      addLicense(
                                        t(
                                          isHighlighted
                                            ? "RenewSubscriptionPlan"
                                            : "subscription_plan"
                                        ),
                                        plan
                                      )
                                    }
                                    disabled={
                                      isHighlighted &&
                                      user?.current_organization?.plan_detail
                                        ?.payment_method === "card" &&
                                      Number(autoSubscibe) === 1 &&
                                      !user?.current_organization?.plan_detail
                                        ?.expired
                                    }
                                  />
                                </Box>

                                {isExpired &&
                                plan?.id ==
                                  user?.current_organization?.plan_detail
                                    ?.plan_id ? (
                                  <Box className="commonBtns w-100 p-0 mt-3">
                                    <ButtonStyled
                                      border={"var(--themeColor2)"}
                                      bg={"var(--themeColor2)"}
                                      color={"var(--white)"}
                                      size="20px"
                                      padding="12px 20px"
                                      weight="bold"
                                      clName="w-100"
                                      className="w-100"
                                      label={t("request_grace_period")}
                                      onClick={() =>
                                        requestGracePeriod(plan.id)
                                      }
                                    />
                                  </Box>
                                ) : (
                                  ""
                                )}
                                {isHighlighted &&
                                  user?.current_organization?.plan_detail
                                    ?.payment_method === "card" && (
                                    <Box className="mt-2">
                                      <Box className="d-flex justify-content-end gap-2">
                                        <SpanStyled color="var(--text)">
                                          {t("auto_renew")}
                                        </SpanStyled>
                                        <Box
                                          className={`switch ${
                                            parseInt(autoSubscibe) === 1
                                              ? "active"
                                              : ""
                                          }`}
                                          onClick={onStatusToggle}
                                          data-tooltip-id="action-tooltip"
                                          data-tooltip-content={t("status")}
                                        >
                                          <SpanStyled className="slider" />
                                        </Box>
                                      </Box>
                                    </Box>
                                  )}

                                <CheckList
                                  // listData={
                                  //   isFree
                                  //     ? basicPlanCheckList
                                  //     : isHighlighted
                                  //     ? professionalPlanCheckList
                                  //     : enterprisePlanCheckList
                                  // }
                                  // listData={
                                  //   features
                                  //     ? JSON.parse(features).map((item, i) => ({
                                  //         id: i + 1,
                                  //         listTxt: item.trim(),
                                  //       }))
                                  //     : []
                                  // }
                                  listData={featuresList}
                                  listBlue={!isFree}
                                />
                              </Box>
                            </Col>
                          );
                        })}
                      <Col lg={6} xl={4} className="mb-4">
                        <Box
                          className={`planDataContainer ${
                            isCustomHighlighted ? "planDataContainerGreen" : ""
                          }`}
                        >
                          <Box className="headToTxt">
                            <SubHeadingStyled color="var(--text)" size="24px">
                              {t("EnterprisePlanCustom")}
                            </SubHeadingStyled>
                            <Box className="descBox">
                              <TextStyled size="15px" color="var(--text2)">
                                {t("CustomSolutionsComprehensive")}
                              </TextStyled>
                            </Box>
                            {isCustomHighlighted ? (
                              <TextStyled size="14px" color="var(--redColor)">
                                {t("expiry_date")}:{" "}
                                {
                                  user?.current_organization?.plan_detail
                                    ?.expiration_date
                                }{" "}
                                {/* Replace with real expiry if available */}
                              </TextStyled>
                            ) : (
                              <>
                                <Box className="subsContactIcon">
                                  <Chat />
                                </Box>
                                <TextStyled size="14px" color="var(--text)">
                                  {t("Contactsalespricing")}
                                </TextStyled>
                              </>
                            )}
                          </Box>
                          <Box className="commonBtns w-100 p-0 mt-3">
                            {isCustomHighlighted ? (
                              <ButtonStyled
                                border={"var(--themeColor2)"}
                                bg={"var(--themeColor2)"}
                                color={"var(--white)"}
                                size="20px"
                                padding="12px 20px"
                                weight="bold"
                                clName="w-100"
                                className="w-100"
                                label={t("RenewPlan")}
                                disabled={
                                  isCustomHighlighted &&
                                  user?.current_organization?.plan_detail
                                    ?.payment_method === "card" &&
                                  Number(autoSubscibe) === 1 &&
                                  !user?.current_organization?.plan_detail
                                    ?.expired
                                }
                                onClick={() =>
                                  addLicense(t("RenewSubscriptionPlan"))
                                }
                              />
                            ) : (
                              <ButtonStyled
                                bg="transparent"
                                border="var(--themeColor2)"
                                color="var(--themeColor2)"
                                size="20px"
                                padding="12px 20px"
                                weight="bold"
                                clName="w-100"
                                className="w-100"
                                label={t("ContactSalesTeam")}
                                onClick={contactSales}
                              ></ButtonStyled>
                            )}
                          </Box>
                          {isCustomHighlighted &&
                          user?.current_organization?.plan_detail?.expired ? (
                            <Box className="commonBtns w-100 p-0 mt-3">
                              <ButtonStyled
                                border={"var(--themeColor2)"}
                                bg={"var(--themeColor2)"}
                                color={"var(--white)"}
                                size="20px"
                                padding="12px 20px"
                                weight="bold"
                                clName="w-100"
                                className="w-100"
                                label={t("request_grace_period")}
                                onClick={() =>
                                  requestGracePeriod(
                                    user?.current_organization?.plan_detail
                                      ?.plan_id
                                  )
                                }
                              />
                            </Box>
                          ) : (
                            ""
                          )}
                          {isCustomHighlighted &&
                            user?.current_organization?.plan_detail
                              ?.payment_method === "card" && (
                              <Box className="mt-2">
                                <Box className="d-flex justify-content-end gap-2">
                                  <SpanStyled color="var(--text)">
                                    {t("auto_renew")}
                                  </SpanStyled>
                                  <Box
                                    className={`switch ${
                                      parseInt(autoSubscibe) === 1
                                        ? "active"
                                        : ""
                                    }`}
                                    onClick={onStatusToggle}
                                    data-tooltip-id="action-tooltip"
                                    data-tooltip-content={t("status")}
                                  >
                                    <SpanStyled className="slider" />
                                  </Box>
                                </Box>
                              </Box>
                            )}
                          <CheckList
                            listData={enterprisePlanCheckList}
                            listBlue={false}
                          />
                        </Box>
                      </Col>
                    </Row>
                  </Box>
                )}

                {/* <Row>
                  <Col lg={6} xl={4} className="mb-4">
                    <Box className="planDataContainer">
                      <Box className="headToTxt">
                        <SubHeadingStyled color="var(--text)" size="24px">
                          {t("BasicPlanFree")}
                        </SubHeadingStyled>
                        <Box className="descBox">
                          <TextStyled size="15px" color="var(--text2)">
                            {t("Thequickestandeasiest")}
                          </TextStyled>
                        </Box>
                        <Box className="subsPriceCurrency">
                          <SpanStyled
                            className="subsPrice"
                            size="28px"
                            color="var(--themeColor2)"
                          >
                            0
                          </SpanStyled>
                          <SpanStyled
                            className="subsCurrency"
                            size="16px"
                            color="var(--themeColor2)"
                          >
                            {t("usd")}
                          </SpanStyled>
                        </Box>
                        <TextStyled size="14px" color="var(--text)">
                          {t("FreeForever")}
                        </TextStyled>
                      </Box>
                      <Box className="commonBtns w-100 p-0 mt-3">
                        <ButtonStyled
                          bg="transparent"
                          border="var(--themeColor2)"
                          color="var(--themeColor2)"
                          size="20px"
                          padding="12px 20px"
                          weight="bold"
                          clName="w-100"
                          className="w-100"
                          label={t("Subscribe")}
                        ></ButtonStyled>
                      </Box>
                      <CheckList
                        listData={basicPlanCheckList}
                        listBlue={false}
                      />
                    </Box>
                  </Col>
                  <Col lg={6} xl={4} className="mb-4">
                    <Box className="planDataContainer planDataContainerBlue">
                      <Box className="headToTxt">
                        <SubHeadingStyled color="var(--text)" size="24px">
                          {t("ProfessionalPlan")}
                        </SubHeadingStyled>
                        <Box className="descBox">
                          <TextStyled size="15px" color="var(--text2)">
                            {t("EnhancedDocumentManagementforProfessionals")}
                          </TextStyled>
                          <TextStyled size="12px" color="var(--redColor)">
                            {t("expiry_date")}: 30/8/2024
                          </TextStyled>
                        </Box>
                        <Box className="subsPriceCurrency">
                          <SpanStyled
                            className="subsPrice"
                            size="28px"
                            color="var(--themeColor)"
                          >
                            300
                          </SpanStyled>
                          <SpanStyled
                            className="subsCurrency"
                            size="16px"
                            color="var(--themeColor)"
                          >
                            {t("usd")}
                          </SpanStyled>
                        </Box>
                        <TextStyled size="14px" color="var(--text)">
                          {t("perusermonth")}
                        </TextStyled>
                      </Box>
                      <Box className="commonBtns w-100 p-0 mt-3">
                        <ButtonStyled
                          border="var(--themeColor)"
                          size="20px"
                          padding="12px 20px"
                          weight="bold"
                          clName="w-100"
                          className="w-100"
                          label={t("RenewPlan")}
                          onClick={() => addLicense(t("RenewSubscriptionPlan"))} // Pass title as argument
                        ></ButtonStyled>
                      </Box>
                      <CheckList
                        listData={professionalPlanCheckList}
                        listBlue={true}
                      />
                    </Box>
                  </Col>
                  <Col lg={6} xl={4} className="mb-4">
                    <Box className="planDataContainer">
                      <Box className="headToTxt">
                        <SubHeadingStyled color="var(--text)" size="24px">
                          {t("EnterprisePlanCustom")}
                        </SubHeadingStyled>
                        <Box className="descBox">
                          <TextStyled size="15px" color="var(--text2)">
                            {t("CustomSolutionsComprehensive")}
                          </TextStyled>
                        </Box>
                        <Box className="subsContactIcon">
                          <Chat />
                        </Box>
                        <TextStyled size="14px" color="var(--text)">
                          {t("Contactsalespricing")}
                        </TextStyled>
                      </Box>
                      <Box className="commonBtns w-100 p-0 mt-3">
                        <ButtonStyled
                          bg="transparent"
                          border="var(--themeColor2)"
                          color="var(--themeColor2)"
                          size="20px"
                          padding="12px 20px"
                          weight="bold"
                          clName="w-100"
                          className="w-100"
                          label={t("ContactSalesTeam")}
                          onClick={contactSales}
                        ></ButtonStyled>
                      </Box>
                      <CheckList
                        listData={enterprisePlanCheckList}
                        listBlue={false}
                      />
                    </Box>
                  </Col>
                </Row> */}
              </SubscriptionWrapper>
              <AddLicenseModal
                title={modalTitle} // Pass modal title
                show={showAddLicenseModal}
                onHide={() => {
                  setPlanData({
                    id: user?.current_organization?.plan_detail?.plan_id,
                    amount: user?.current_organization?.plan_detail?.price,
                    expired: user?.current_organization?.plan_detail?.expired,
                  });
                  setShowAddLicenseModal(false);
                }}
                planInfo={planData}
                action={action}
              />
              <ContactSalesModal
                show={showContactSalesModal}
                onHide={() => setShowContactSalesModal(false)}
              />
              <CreditCardInfoModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                // customerId={user?.tap_customer_id}
              />
            </FormDataContainer>
          </Col>
        </Row>
      </Box>
    </SettingsWrapper>
  );
};

export default SubscriptionPlan;
